import React, { useCallback, useContext } from 'react';
import { useNavigate } from 'react-router-dom';

import {
  ButtonBar,
  ScreenHeader
} from '../../components';
import { WillAssetSummary } from '../../components/v2/will-asset-summary';
import { AssetsContext, AssetsProvider } from '../../context';

import { hasMinorBeneficiaries } from './new-will-single-beneficiary-screen';

import { NewWillContext } from '.';


export function NewWillAssetSummaryScreen() {
  const navigate = useNavigate();
  
  const { will } = useContext(NewWillContext);
  const { assets } = useContext(AssetsContext);

  const handleBack = useCallback(() => {
    navigate('../asset-distribution');
  }, [ navigate ]);

  const handleNext = useCallback(() => {
    navigate('../add-asset');
  }, [ navigate ]);

  const handleContinue = useCallback(() => {
    if (hasMinorBeneficiaries(will)) {
      return navigate('../minor-beneficiaries');
    }
    
    navigate('../pet-arrangements');
  }, [ navigate, will ]);

  const handleRemoveAsset = useCallback((id: string) => {
    console.log('Removing asset at index:', id);
  }, []);

  const handleEditAsset = useCallback((id: string) => {
    navigate(`../add-asset?edit=${id}`);
  }, [ navigate ]);

  return (
    <div className="new-will-asset-summary-screen screen">
      <ScreenHeader 
        title="Asset Summary"
        description="Summary of your assets and their beneficiaries"
        handleBack={handleBack} 
        steps={6} 
        step={2} 
      />
      
      <AssetsProvider>
        <WillAssetSummary handleRemoveAsset={handleRemoveAsset} handleEditAsset={handleEditAsset} />
      </AssetsProvider>
      
      <ButtonBar 
        handlePrimary={handleNext} 
        primaryText="Add Asset" 
        handleSecondary={handleContinue} 
        secondaryText="Continue" 
      />
    </div>
  );
}
